import React, { createContext, useContext, useState, ReactNode } from "react";

export type QuickIslandView =
  | "map-styles"
  | "simulation"
  | "search"
  | "route"
  | "camera-controls"
  | null;

interface QuickIslandContextType {
  expandedView: QuickIslandView;
  openIsland: (view: QuickIslandView) => void;
  closeIsland: () => void;
  searchBusy: boolean;
  setSearchBusy: (busy: boolean) => void;
  isSearching: boolean;
  setIsSearching: (searching: boolean) => void;
}

const QuickIslandContext = createContext<QuickIslandContextType | null>(null);

interface QuickIslandProviderProps {
  children: ReactNode;
}

export function QuickIslandProvider({ children }: QuickIslandProviderProps) {
  const [expandedView, setExpandedView] = useState<QuickIslandView>(null);
  const [searchBusy, setSearchBusy] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const openIsland = (view: QuickIslandView) => {
    setExpandedView(view);
  };

  const closeIsland = () => {
    setExpandedView(null);
  };

  const value: QuickIslandContextType = {
    expandedView,
    openIsland,
    closeIsland,
    searchBusy,
    setSearchBusy,
    isSearching,
    setIsSearching,
  };

  return (
    <QuickIslandContext.Provider value={value}>
      {children}
    </QuickIslandContext.Provider>
  );
}

export function useQuickIsland() {
  const context = useContext(QuickIslandContext);
  if (!context) {
    throw new Error("useQuickIsland must be used within a QuickIslandProvider");
  }
  return context;
}
